import { RolloutMonitoring } from '../types';

export const FETCH_ROLLOUT_MONITORING_SUCCESS = 'FETCH_ROLLOUT_MONITORING_SUCCESS';
export const ROLLOUT_MONITORING_FOR_RELEASES_UPDATED = 'ROLLOUT_MONITORING_FOR_RELEASES_UPDATED';

export interface RolloutMonitoringResponse {
    rolloutMonitoring: RolloutMonitoring;
    releaseId: string;
    appId: string;
    orgId: string;
}
export interface FetchRolloutMonitoringSuccessAction {
    type: typeof FETCH_ROLLOUT_MONITORING_SUCCESS;
    payload: RolloutMonitoringResponse;
}

export const fetchRolloutMonitoringSuccess: (
    payload: RolloutMonitoringResponse,
) => FetchRolloutMonitoringSuccessAction = (payload) => {
    return {
        type: FETCH_ROLLOUT_MONITORING_SUCCESS,
        payload,
    };
};

export interface RolloutMonitoringUpdatedAction {
    type: typeof ROLLOUT_MONITORING_FOR_RELEASES_UPDATED;
    payload: RolloutMonitoringResponse[];
}

export const updateRolloutMonitoringForReleases: (
    payload: RolloutMonitoringResponse[],
) => RolloutMonitoringUpdatedAction = (payload) => {
    return {
        type: ROLLOUT_MONITORING_FOR_RELEASES_UPDATED,
        payload,
    };
};
